export * from './fond-entfernt.interface';
